// extracted by mini-css-extract-plugin
export var box = "_5r-0";
export var check = "_5r-1";
export var checkboxButton = "_5r-6";
export var checkboxGroup = "_5r-5";
export var disabled = "_5r-7";
export var ghost = "_5r-9";
export var input = "_5r-2";
export var label = "_5r-4";
export var normal = "_5r-8";
export var uncheck = "_5r-3";